import { PageHeaderType, type LayoutSpec } from '../../../../types/LayoutConfig';
import { DEFAULT_DEALER_SPACE_DATE_RANGE_VALUE } from '../../Panels/Dealer/DealerSpaceParameters';
import { DEFAULT_LAYOUT_ID } from '../tokens';
import { CUSTOMER_ACTIVITY_LAYOUT } from './CustomerActivity';

export const CUSTOMER_ACTIVITY_LAYOUT_SPEC: LayoutSpec = {
  templateId: DEFAULT_LAYOUT_ID,
  label: 'Customer Activity',
  id: DEFAULT_LAYOUT_ID,
  pageHeader: PageHeaderType.DealerSpaceParameters,
  dockViewLayout: CUSTOMER_ACTIVITY_LAYOUT,
  spaceParameterValues: {
    DateRange: DEFAULT_DEALER_SPACE_DATE_RANGE_VALUE,
  },
  constraints: [],
  collapsablePanels: [],
};
